<template>
  <VanPopup
    v-model:show="store.showJumpListModal"
    class="max-h-[90%] min-h-[50%]"
    closeable
    position="bottom"
    round
  >
    <div class="py-4">
      <h2 class="text-base font-bold text-center">
        {{ t("game.pleaseSelectDialogue") }}
      </h2>

      <div class="flex gap-2.5 mt-6 px-11">
        <p class="my-0.5">
          {{
            store.connectionType === "option"
              ? $t("game.player")
              : getCharacterNameByDialogId(store.activeDialog.id!)
          }}：
          {{
            store.connectionType === "option"
              ? store.activeDialogOption.text
              : store.activeDialog.text
          }}
        </p>
      </div>

      <div
        class="my-3 px-2 flex overflow-x-auto whitespace-nowrap justify-center cursor-pointer"
      >
        <div
          v-for="(item, idx) in SubTab"
          :key="idx"
          :class="[
            'flex-1 text-center px-2 py-1 border border-r-0 last:border-r',
            store.dialogShowTab === item && 'bg-primary',
          ]"
          @click="clickSubTab(item)"
        >
          {{ t(`game.role.${item}`) }}
        </div>
      </div>

      <VanRadioGroup v-model="store.activeCheckedJumpDialogId">
        <VanRadio
          :name="null"
          checked-color="#ee0a24"
          class="bg-neutral p-2.5 my-2.5"
        >
          <div class="flex gap-1">
            <span class="badge badge-primary rounded">{{
              $t("game.notSetJump")
            }}</span>
          </div>
        </VanRadio>
        <template v-for="(dialogId, i) in store.dialogShowList">
          <VanRadio
            v-if="dialogId !== store.activeDialog.id"
            :key="dialogId"
            :name="dialogId"
            checked-color="#ee0a24"
            class="bg-neutral p-2.5 my-2.5"
          >
            <div class="flex gap-1">
              <h2>#{{ i + 1 }} {{ getCharacterNameByDialogId(dialogId) }}：</h2>
              <h3 class="mr-4">
                {{ store.dialogMap[dialogId].text }}
              </h3>
            </div>
          </VanRadio>
        </template>
        <VanRadio
          v-if="columns.length > 0"
          checked-color="#ee0a24"
          class="bg-neutral p-2.5 my-2.5"
          name="node"
        >
          <div class="flex gap-1" @click="showPicker = true">
            <div class="mr-4 flex items-center">
              <p>{{ t("game.jumpAnotherNode") }}</p>
              <span class="text-xs ml-3">
                {{
                  activeNode[0]
                    ? store.nodeMap[Number(activeNode[0].split("-")[1])].name
                    : t("game.selectContentNode")
                }}
                <i class="iconfont icon-down1 text-xs"></i>
              </span>
            </div>
          </div>
        </VanRadio>
      </VanRadioGroup>

      <div class="text-center">
        <button class="btn btn-primary min-w-[200px]" @click="clickConfirm">
          {{ t("Buttons.confirm") }}
        </button>
      </div>
    </div>
  </VanPopup>

  <VanPopup v-model:show="showPicker" position="bottom" round>
    <VanPicker
      v-model="activeNode"
      :cancel-button-text="t('Buttons.cancel')"
      :columns="columns"
      :confirm-button-text="t('Buttons.momentSave')"
      :title="t('game.selectContentNode')"
      @cancel="onCancel"
      @confirm="onConfirm"
    />
  </VanPopup>
</template>

<script lang="ts" setup>
import { ApiGetGalGameDialog } from "@/apis/gal-game";
import { useGalGameEditor } from "@/stores/galGameEditor";
import {
  PickerConfirmEventParams,
  showFailToast,
  showLoadingToast,
} from "vant";
import { computed } from "vue";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const store = useGalGameEditor();
// const checked = ref<string | number>(-1);
const showPicker = ref(false);
const activeNode = ref<string[]>([]);
const SubTab = [0, 1, 2, 4, 3];

const clickSubTab = (tab: number) => {
  store.dialogShowTab = tab;
  if (tab === 0) {
    store.dialogShowList = store.dialogList;
  } else {
    store.dialogShowList = store.dialogList.filter(
      (v) => store.dialogMap[v].character.role === tab
    );
  }
};

const columns = computed(() => {
  const { nodes, nodeMap, activeNode } = store;
  const map: { text: string; value: string }[] = [];
  nodes.forEach((nodeId) => {
    const node = nodeMap[nodeId];
    if (node.dialogzzCount === 0 || nodeId === activeNode.id) return;
    map.push({
      text: node.name!,
      value: "node-" + node.id!,
    });
  });
  return map;
});

const getCharacterNameByDialogId = (dialogId: number) => {
  const { dialogMap, characterIdMap } = store;
  const dialog = dialogMap[dialogId];
  if (!dialog) return "";
  let { role, name } = characterIdMap[dialog.characterId!];
  let text = name;
  name = name ? `（${name}）` : "";
  text = `${t(`game.role.${role}`)}${name}`;
  return text;
};

const clickConfirm = async () => {
  const loading = showLoadingToast({
    message: t("Message.saving"),
    duration: 0,
  });
  if (store.activeCheckedJumpDialogId === -1) {
    loading.close();
    showFailToast({ message: t("Message.pleaseSelectDialogText") });
    return;
  }
  let nextDialogId = 0;
  if (store.activeCheckedJumpDialogId === "node") {
    if (!activeNode.value[0]) {
      loading.close();
      showFailToast({ message: t("Message.pleaseSelectContentNode") });
      return;
    }

    const nodeId = Number(activeNode.value[0].split("-")[1]);
    const { itemzz } = await ApiGetGalGameDialog(nodeId);
    nextDialogId = itemzz[0].id;
  } else {
    nextDialogId = store.activeCheckedJumpDialogId as number;
  }
  if (store.connectionType === "dialog") {
    store.activeDialog.nextDialogId = nextDialogId;
    const res = await store.saveDialog();
    store.activeDialog.nextDialog = res.item.nextDialog;
  } else if (store.connectionType === "option") {
    store.activeDialogOption.nextDialogId = nextDialogId;
    const res = await store.saveDialogOption();
    store.activeDialogOption.nextDialog = res.item.nextDialog;
  }

  loading.close();
  store.showJumpListModal = false;
};

const onConfirm = ({ selectedValues }: PickerConfirmEventParams) => {
  showPicker.value = false;
};
const onCancel = () => {
  showPicker.value = false;
};
</script>
